/** Display the stored standard-contract mapping without implying exclusion from Positions. */
export function bilateralProjectionPresentation(
  status: string | null | undefined,
  reason?: string | null,
  reasonCode?: string | null,
) {
  // Older saved blotter rows have the reason text but no reason code.
  const customWindow = status === "not_eligible" && (
    reasonCode === "unsupported_period" ||
    (!reasonCode && /^(delivery window is not|one or more calculation periods is not) a complete standard EEX tenor\.?$/i.test(reason?.trim() ?? ""))
  );
  if (customWindow) {
    return {
      label: "Custom delivery window",
      description: "The delivery window does not match a single standard EEX contract period. Supported whole-month bilateral windows can still contribute monthly exposure in Positions while remaining one contractual deal.",
      customWindow: true,
    };
  }
  const labels: Record<string, string> = {
    projected: "Standard EEX periods",
    not_eligible: "No standard EEX mapping",
    pending: "Mapping pending",
    failed: "Mapping failed",
  };
  return {
    label: labels[status ?? ""] ?? "Mapping not assessed",
    description: reason ?? null,
    customWindow: false,
  };
}
